module.exports = __webpack_public_path__ + "static/media/Ikenna2.1005808a.png";